export default "__VITE_ASSET__Dx9vnedJ__"